import { render, staticRenderFns } from "./Customer-vieworder.vue?vue&type=template&id=d92bdd76"
import script from "./Customer-vieworder.vue?vue&type=script&lang=js"
export * from "./Customer-vieworder.vue?vue&type=script&lang=js"
import style0 from "./Customer-vieworder.vue?vue&type=style&index=0&id=d92bdd76&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports